function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { ComponentFromInput, parseValidators, convertTrueFalseStringToBoolean } from '../util';
import FormRow from './FormRow';
var nonAlphaNumeric = /[^a-zA-Z0-9]/g;
var determineCheckboxValues = function determineCheckboxValues(currentValues, e) {
  if (e.target.checked) {
    return currentValues.concat(convertTrueFalseStringToBoolean(e.target.value));
  }
  return currentValues.filter(function (value) {
    return value !== convertTrueFalseStringToBoolean(e.target.value);
  });
};
var Checkbox = function Checkbox(_ref) {
  var description = _ref.description,
    disabled = _ref.disabled,
    label = _ref.label,
    messages = _ref.messages,
    name = _ref.name,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    validators = _ref.validators,
    required = _ref.required,
    options = _ref.options,
    _ref$onChange = _ref.onChange,
    customOnChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    value = _ref.value,
    _ref$shouldUnregister = _ref.shouldUnregister,
    shouldUnregister = _ref$shouldUnregister === void 0 ? false : _ref$shouldUnregister,
    _ref$dataTrack = _ref.dataTrack,
    dataTrack = _ref$dataTrack === void 0 ? null : _ref$dataTrack,
    _ref$dataTrackAction = _ref.dataTrackAction,
    dataTrackAction = _ref$dataTrackAction === void 0 ? null : _ref$dataTrackAction,
    _ref$dataTrackLabel = _ref.dataTrackLabel,
    dataTrackLabel = _ref$dataTrackLabel === void 0 ? null : _ref$dataTrackLabel;
  var _useFormContext = useFormContext(),
    register = _useFormContext.register,
    control = _useFormContext.control;
  var registerProps = !options ? register(name, parseValidators({
    validators: validators,
    messages: messages
  })) : null;
  return /*#__PURE__*/React.createElement(FormRow, {
    messages: messages,
    description: description,
    label: options ? label : undefined,
    name: name,
    required: typeof required !== 'undefined' ? required : !!validators,
    styles: styles
  }, options ? /*#__PURE__*/React.createElement(Controller, {
    shouldUnregister: shouldUnregister,
    name: name,
    control: control,
    rules: parseValidators({
      messages: messages,
      validators: validators
    }),
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
        _onChange = _ref2$field.onChange,
        _onBlur = _ref2$field.onBlur,
        value = _ref2$field.value,
        fieldName = _ref2$field.name;
      var currentValue = Array.isArray(value) ? value : [value].filter(function (notFalsy) {
        return notFalsy;
      });
      return options.map(function (option) {
        return /*#__PURE__*/React.createElement("div", {
          key: option.value,
          className: "form-check ".concat(styles && styles.controlClass ? styles.controlClass : '')
        }, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          className: "form-check-input",
          id: "".concat(fieldName).concat(option.value).replace(nonAlphaNumeric, ''),
          name: "".concat(fieldName, "[]"),
          value: option.value,
          onChange: function onChange(e) {
            var checkboxValues = determineCheckboxValues(currentValue, e);
            customOnChange(checkboxValues);
            return _onChange(checkboxValues);
          },
          onBlur: function onBlur(e) {
            return _onBlur(determineCheckboxValues(currentValue, e));
          },
          checked: currentValue.indexOf(option.value) !== -1,
          "data-cy": name,
          "data-track": dataTrack,
          "data-track-action": dataTrackAction,
          "data-track-label": dataTrackLabel
        }), /*#__PURE__*/React.createElement("label", {
          className: "form-check-label",
          htmlFor: "".concat(fieldName).concat(option.value).replace(nonAlphaNumeric, '')
        }, option.label));
      });
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "form-check ".concat(styles && styles.controlClass ? styles.controlClass : '')
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    className: "form-check-input",
    disabled: disabled,
    id: name.replace(nonAlphaNumeric, ''),
    name: name
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, registerProps, {
    onChange: function onChange() {
      customOnChange.apply(void 0, arguments);
      return registerProps.onChange.apply(registerProps, arguments);
    },
    value: value,
    "data-cy": name,
    "data-track": dataTrack,
    "data-track-action": dataTrackAction,
    "data-track-label": dataTrackLabel
  })), /*#__PURE__*/React.createElement("label", {
    className: "form-check-label",
    htmlFor: name.replace(nonAlphaNumeric, '')
  }, /*#__PURE__*/React.createElement(ComponentFromInput, {
    input: label
  }), validators ? /*#__PURE__*/React.createElement("em", {
    className: "text-danger"
  }, "*") : null)));
};
export default Checkbox;